import api from '../../config/axios.js';
import moment from 'moment';
import { isAuthenticated } from '@/services/authService';

const state = {
    id: '',
    name: "",
    cell_phone: "",
    commercial_phone: "",
    active: "",
    email: "",
    company_id: "",
    created_at: "",
    configurations: {},
    errorRegister: "",
    errorForgotPasswordSendEmail: "",
    configurationSftp: [],
    currentConfigurationSftp: {},
    usersList: [],
    currentDeleteUser: {},
    usersForCompanyId: []
}
const getters = {
    getId: state => state.id,
    getName: state => state.name,
    getPhone: state => state.phone,
    getBirthday: state => (state.birthday != null) ? moment(state.birthday).format('DD/MM/YYYY') : 'Não Informado',
    getActive: state => state.active,
    getEmail: state => state.email,
    getCompany_id: state => state.company_id,
    getCreatedAt: state => (state.created_at != null) ? moment(state.created_at).format('DD/MM/YYYY') : 'Não Informado',
    getConfigurations: state => state.configurations,
    getErrorRegister: state => state.errorRegister,
    getErrorForgotPasswordSendEmail: state => state.errorForgotPasswordSendEmail,
    getConfigurationSftp: state => state.configurationSftp,
    getCurrentConfigurationSftp: state => state.currentConfigurationSftp,
    getUsersList: state => state.usersList,
    getCurrentDeleteUser: state => state.currentDeleteUser,
    getUsersForCompanyId: state => state.usersForCompanyId
}
const actions = {
    // REALIZANDO CRIAÇÃO DA INSTALAÇÃO
    async sendRegister({ commit }, obj){
        await api.axios.post('/api/installation', obj).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorRegister", error.response.data);
            }
        }).then(response => {
            if(response && response.data && response.data.token != undefined){
                commit("setTokenSession");
            } else if(response && response.data) {
                location.reload();
            }
        });
    },
     // REALIZANDO CRIAÇÃO DA EMPRESA/USUÁRIO
     async sendRegisterPage({ commit }, obj){
        await api.axios.post('/api/register', obj).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorRegister", error.response.data);
            }
        }).then(response => {
            if(response && response.data && response.data.token != undefined){
                commit("setTokenSession");
            } else if(response && response.data) {
                location.reload();
            }
        });
    },
    // ENVIAR EMAIL DE ESQUECI MINHA SENHA
    async sendForgotPasswordSendEmail({ commit }, obj){
        await api.axios.post('/api/reset/password/email', {email: obj.email}).catch((error) => {
            if(error.response && error.response.data){
                commit("setErrorForgotPasswordSendEmail", error.response.data);
            }
        }).then(response => {
            if(response && response.status == 200){
                obj.router.push('/send-email-forgot-password');
            }
        });
    },
    // SETANDO ERRO EM VALIDAÇÕES FORGOT PASSWORD
    async setErrorForgotPasswordSendEmail({ commit }, message){
        commit("setErrorForgotPasswordSendEmail", message);
    },
    // REALIZANDO LOGIN
    async sendCreateSession(obj){
        await window.axios.post('/api/login', obj).then(response => {
            if(response && response.data && response.data.token != undefined){
                window.location.href = "/dashboard";
            }         
        });
    },
    // REALIZAR LOGOFF
    async logoffSession() {
        await window.axios.post('/api/logout').then(function(response){
            try {
                if(response.status == 200){
                    window.location.href = "/login";
                } else {
                    window.location.href = "/login";
                }
            } catch(error){
                window.location.href = "/login";
            }
        });
    },
    // RECUPERANDO CONFIGURAÇÕES SFTP
    async setConfigurationSftp({commit}) {
        await api.axios.get('/api/configurations/sftp').then(function(response){
            if(response.status == 200){
                commit('setConfigurationSftp', response.data);
            }
        });
    },
    // RESETANDO CAMERAS
    resetUsersForCompanyId({commit}) {
        commit("resetUsersForCompanyId");
    },
    // RECUPERANDO OS USUÁRIOS DE UMA COMPANY_ID
    async setUsersForCompanyId({commit}, company_id) {
        await api.axios.get('/api/users/installation/id/'+company_id).then(function(response){
            if(response.status == 200){
                commit('setUsersForCompanyId', response.data);
            }
        });
    },
    // BUSCAR SESSAO
    async reloadSession({ commit }) {
        await window.axios.post('/api/user').catch(function(){
            if(window.location.pathname != "/login" && window.location.pathname != "/"){
                window.location.href = "/login";
            }
        }).then(function(response){
            if(response.status == 200){
                commit('sendCreateSession', response.data);
                window.location.href = "/dashboard";
            }
        });
    },
    // BUSCAR CONFIGURAÇÕES
    async setConfiguration({ commit }) {
        if(await isAuthenticated()){
            // if(window.location.pathname == "/login" || window.location.pathname == "/register" || window.location.pathname == "/forgot-password" || window.location.pathname == "/send-email-forgot-password" || window.location.pathname == "/terms"){
            //     window.location.href = "/";
            // }
            await api.axios.get('/api/configurations').catch(function(){
                if(window.location.pathname != "/home" && window.location.pathname != "/login" && window.location.pathname != "/" && window.location.pathname != "/register" && window.location.pathname != "/forgot-password" && window.location.pathname != "/send-email-forgot-password" && window.location.pathname != "/terms"){
                    window.location.href = "/login";
                }
            }).then(function(response){
                if(response.status == 200){
                    commit('setConfiguration', response.data);
                }
            });
        } else {
            if(window.location.pathname != "/home" && window.location.pathname != "/login" && window.location.pathname != "/" && window.location.pathname != "/register" && window.location.pathname != "/forgot-password" && window.location.pathname != "/send-email-forgot-password" && window.location.pathname != "/terms"){
                window.location.href = "/login";
            }
        }
    },
    reloadData({ commit }, data) {
        commit('sendCreateSession', data);
    },
    setNewToken({ commit }, data){
        commit("setNewToken", data);
    },
    setCurrentConfigurationSftp({ commit }, data){
        commit("setCurrentConfigurationSftp", data);
    },
    // LISTANDO USUÁRIOS
    async setUsersList({ commit }){
        await api.axios.get('/api/users').catch(() => {
            commit("setUsersList", []);
        }).then(response => {
            if(response && response.data){
                commit("setUsersList", response.data);
            }
        });
    },
    async setCurrentDeleteUser({ commit }, data){
        commit('setCurrentDeleteUser', data);
    }
}
const mutations = {
    // SETANDO INFORMACOES DE LOGIN
    sendCreateSession: function(state, data){
        state.id = data.id;
        state.name = data.name;
        state.cell_phone = data.cell_phone;
        state.commercial_phone = data.commercial_phone;
        state.active = data.active;
        state.email = data.email;
        state.company_id = data.company_id;
        state.created_at = data.created_at;
    },
    //BUSCANDO CONFIGURAÇÕES ATUAIS
    setConfiguration: function(state, data){
        state.configurations = data;
        if(data && data.company_id){
            state.company_id = data.company_id;
        }
    },
    setNewToken: function(state, data){
        state.configurations.companyToken = data;
    },
    setTokenSession: function(){
        window.location.href = "/installation";
    },
    setErrorRegister: function(state, data){
        state.errorRegister = data;
    },
    setErrorForgotPasswordSendEmail: function(state, data){
        state.errorForgotPasswordSendEmail = data;
    },
    setConfigurationSftp: function(state, data){
        state.configurationSftp = data;
    },
    setCurrentConfigurationSftp: function(state, data){
        state.currentConfigurationSftp = data;
    },
    setUsersList: function(state, data){
        state.usersList = data;
    },
    setCurrentDeleteUser: function(state, data){
        state.currentDeleteUser = data;
    },
    setUsersForCompanyId: function(state, data){
        state.usersForCompanyId = data;
    },
    // RESETANDO CAMERAS
    resetUsersForCompanyId: function(state){
        state.usersForCompanyId = [];
    }
}
export default {
    state,
    getters,
    actions,
    mutations
}
